import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import apiClient from "../Utils/apiClient";

export default function VehicleTrackingAction({ props }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRelay = async (type) => {
    try {
      const parameter = type === "OFF" ? "1" : "2";

      console.log("📤 Sending Relay Command:", {
        type,
        parameter,
        imei: props?.imei,
      });

      const res = await apiClient.post("/instruction/relay", {
        parameter,
        imeis: [props?.imei],
      });

      console.log("✅ API Response:", res.data);
    } catch (err) {
      console.log(
        "❌ Error:",
        err?.response?.data || err.message
      );
    }

    handleClose();
  };

  // ✅ ENGINE STATUS (from DB)
  const isEngineOn = props?.engineStatus ?? true;

  return (
    <>
      {/* MENU ICON */}
      <IconButton onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>

      {/* DROPDOWN MENU */}
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {isEngineOn ? (
          <MenuItem onClick={() => handleRelay("OFF")}>
            Turn OFF Engine
          </MenuItem>
        ) : (
          <MenuItem onClick={() => handleRelay("ON")}>
            Turn ON Engine
          </MenuItem>
        )}
      </Menu>
    </>
  );
}